var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3A414C",
  fillRule: "nonzero",
  d: "M16.5 8.75a4.75 4.75 0 1 0-9.5 0 4.74 4.74 0 0 0 2 3.868V13a.5.5 0 0 0 .5.5h.5V19l2 1 1.51-1.487-.503-.264a.289.289 0 0 1 .008-.516l.485-.233V17l-.484-.241a.29.29 0 0 1 0-.518L13.5 16l-.717-.717a.288.288 0 0 1 .075-.463l.642-.32v-1h.5a.5.5 0 0 0 .5-.5v-.382a4.74 4.74 0 0 0 2-3.868M11.75 6a1.75 1.75 0 1 1-.001 3.501 1.75 1.75 0 0 1 .001-3.5"
})));
export { SvgKey as ReactComponent };
export default __webpack_public_path__ + "static/media/key.55e7af8b.svg";